export default [
  {
    path: 'top-up/history',
    name: 'top-up-history',
    component: () => import('./history/TopUpHistoryPage.vue')
  }
]
